export default __webpack_public_path__ + "static/media/razon-y-ley.0f857d69.jpeg";